import { FormatConfig } from '@y42/model';
import { ConditionalFormattingRule } from '../conditional-formatting.model';
import { fieldId } from '../field-id.model';
import { BaseEchartsSettingsModel, MarkTypeEnum } from './base-echart-settings.model';
import { Y42SeriesModel } from './common';
import { ColorByArea } from './sub-models/color.model';
import { DatosAxisPointer } from './sub-models/datos-axis.model';
import { LabelModel } from './sub-models/label.model';
import { SizeModel } from './sub-models/size.model';
import { TooltipModel } from './sub-models/tooltip.model';

export class TreemapSettingsModel extends BaseEchartsSettingsModel<{ field_id: fieldId | null }> {
  constructor(
    public series: TreemapSeriesModel[] = [],
    public size: [] | [SizeModel] = [],
    public conditionalFormattingRules?: ConditionalFormattingRule[],
    public colorBy?: {
      area: ColorByArea;
      hiddenValues: Record<string, boolean>;
    },
    show_legend?: boolean,
    axisPointer?: DatosAxisPointer,
    breakdowns?: fieldId[],
  ) {
    super(series, show_legend, axisPointer, [], breakdowns);
  }
}

export class TreemapSeriesModel implements Y42SeriesModel {
  constructor(
    public field_id: fieldId,
    public mark: MarkTypeEnum = MarkTypeEnum.Area,
    public stack_name = 1, // need as unique id
    public format = 'inherit',
    public formatConfig?: FormatConfig,
    public show_measures_label?: boolean,
    public show_right_axis = false,
    public label: LabelModel = new LabelModel(),
    public tooltip?: TooltipModel,
    public hideFalsyValues = true,
  ) {}
}
